// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const rayquaza: PokeData = {
  "id": 384,
  "name": "rayquaza",
  "height": 70,
  "weight": 2065,
  "base_experience": 306,
  "types": [
    PokeType.DRAGON,
    PokeType.FLYING
  ],
  "api_moves": [
    "fly",
    "hyper-beam",
    "rest",
    "scary-face",
    "outrage",
    "twister",
    "crunch",
    "extreme-speed",
    "ancient-power",
    "hyper-voice",
    "dragon-claw",
    "dragon-dance",
    "air-slash",
    "dragon-pulse",
    "hurricane",
    "dragon-ascent"
  ],
  "moves": [
    "scary-face",
    "outrage",
    "crunch",
    "ancient-power",
    "hyper-voice",
    "dragon-claw",
    "dragon-dance",
    "air-slash",
    "dragon-pulse",
    "hurricane",
    "inner-spirit",
    "roost",
    "great-roar"
  ],
  "evolution_chain": {
    "id": 200,
    "item": null,
    "species": [
      {
        "name": "rayquaza",
        "order": 414,
        "types": [
          PokeType.DRAGON,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 114,
    "speed": 111,
    "ability_power": 175
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
